import type { CustomNode } from '#models/Nodes/CustomNode'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import BottomActions from '../BottomActions'
import SearchField from '../SearchField'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

type Props = {
  node: CustomNode
  viewModel: ViewModel
}

const CustomLinksOnly = ({ viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph className={styles.defaultWeight} variant='subtitle2'>
        {viewModel.node.text}
      </Paragraph>
      <Paragraph variant='body2'>{viewModel.node.subtext}</Paragraph>
      {!viewModel.node && (
        <SearchField onChange={viewModel.handleSearchFormChange} />
      )}
      {viewModel.options.map((option, index) => (
        <Paragraph
          className={styles.link}
          component='a'
          key={index}
          onClick={viewModel.handleLinkClick(option)}
          variant='body1'
        >
          {option.text}
        </Paragraph>
      ))}
    </StepContent>
    {viewModel.showButtons && (
      <BottomActions
        // @ts-expect-error@2322
        onNext={viewModel.showContinue && viewModel.handleNext}
        showBack={viewModel.node.allowBack}
      />
    )}
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomLinksOnly)
component.displayName = 'CustomLinksOnly'
export default component
